import React, { MouseEventHandler, useCallback, useRef } from 'react'
import NavigationNavItem from './NavigationNavItem'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import ListItem from 'components/Luxkit/List/ListItem'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'

interface Props {
  currentActiveNavItem?: App.NavItem
  isOpen: boolean
  navItem: App.NavItem
  onClose: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  onSubNavClick: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  onToggle: (navItem: App.NavItem) => void
}

function NavigationNavDropdownItem(props: Props) {
  const {
    currentActiveNavItem,
    isOpen,
    navItem,
    onClose,
    onSubNavClick,
    onToggle,
  } = props

  const navItemRef = useRef<HTMLButtonElement>(null)

  const handleToggle = useCallback(() => {
    onToggle(navItem)
  }, [navItem, onToggle])

  return <>
    <NavigationNavItem
      ref={navItemRef}
      navItem={navItem}
      onClick={handleToggle}
      open={isOpen}
      active={navItem === currentActiveNavItem}
    />
    <Dropdown
      triggerRef={navItemRef}
      open={isOpen && navItemRef.current?.style.display !== 'none'}
      onClose={onClose}
    >
      <DropdownContainer fit="dropdown-items">
        {navItem.items?.map(item => (
          <ListItem
            size="small"
            key={item.id}
            id={item.id}
            aria-label={`Select ${item.text}`}
            onClick={onSubNavClick}
            to={item.to}
            href={item.href}
            label={item.text}
            className={item.linkClass}
            endIcon={item.newLabel && <StatusLabel variant="confirmation">New</StatusLabel>}
            selected={item === currentActiveNavItem}
          />
        ))}
      </DropdownContainer>
    </Dropdown>
  </>
}

export default NavigationNavDropdownItem
